import React, { useContext } from 'react';
import classNames from 'classnames';
import PlusIcon from 'icons/Plus.icon';
import { Link } from 'react-router-dom';
import { CREATE_DEAL_ROUTE } from 'data/global';
import { useTranslation } from 'react-i18next';
import CreateDataRoomContext from 'providers/CreateDataRoom/CreateDataRoom.context';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import { Button } from 'ncoded-component-library';

import './AddNewListingButton.styles.scss';

type AddNewListingButtonProps = {
  className?: string;
};

const AddNewListingButton: React.FC<AddNewListingButtonProps> = (props) => {
  const { className } = props;

  const { enterprise } = useContext(CurrentUserContext);
  const { openCreateDataRoomModal } = useContext(CreateDataRoomContext);

  const { isRWC } = enterprise || {};

  const classes = classNames('add-new-listing-button', className);
  const linkClasses = classNames(classes, 'ncoded-button ncoded-button--solid');

  const { t } = useTranslation();

  if (isRWC) {
    return (
      <Button className={classes} onClick={openCreateDataRoomModal}>
        <PlusIcon />
        {t('newDataRoom')}
      </Button>
    );
  }

  return (
    <Link className={linkClasses} to={CREATE_DEAL_ROUTE}>
      <PlusIcon />
      {t('newDeal')}
    </Link>
  );
};

export default AddNewListingButton;
